import { useCallback, useEffect, useState } from "react";

import { useClientSync } from "data/hub/sync";

function useSyncClientMeetings(clientId, onComplete) {
  const [error, setError] = useState(null);
  const { sync, run } = useClientSync(clientId);

  const triggerSync = useCallback(() => {
    run.meetings(onComplete, setError);
  }, [onComplete, run]);

  useEffect(() => {
    triggerSync();
    // eslint-disable-next-line
  }, []);

  return {
    error: error,
    inProgress: sync.meetings.inProgress,
    run: triggerSync,
  };
}

export default useSyncClientMeetings;
